import { resolveAssetUrl } from '../../company/helpers/ComapnyHelpers';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CloseIcon from '@mui/icons-material/Close';
import FilterListIcon from '@mui/icons-material/FilterList';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import PodcastsIcon from '@mui/icons-material/Podcasts';
import SpeedIcon from '@mui/icons-material/Speed';
import { Badge, Box, Drawer, FormControl, IconButton, MenuItem, Select, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useEffect, useMemo, useRef, useState } from "react";
import Carousel from "react-multi-carousel";
import { useNavigate } from "react-router-dom";
import { Loading } from "../../../components";
import { CarouselContainer, CarouselItem } from "../../../pages/offers-shopkeeper/OffersShopkeeper.styles";
import { useToastStore } from "../../../stores";
import { colorPrimary, colorSubText } from "../../../theme";
import { formatCurrencyBRL } from "../../../utils/mask/MaskUtils";
import { AnuncioGrid } from "../components/AnuncioGridDesktop";
import { AnuncioItemCard } from "../components/AnuncioItemCard";
import { CombustivelFilterCard } from "../components/CombustivelFilterCard";
import { ConcessionariaMiniCard } from "../components/ConcessionariaResumoCard";
import { MarcasFilterCard } from "../components/MarcasFilterCard";
import { PrecoFilterCard } from "../components/PrecoFilterCard";
import { ResumoCard } from "../components/ResumoCard";
import { SearchCard } from "../components/SearchCard";
import { TipoFilterCard } from "../components/TipoFilterCard";
import { AnunciosShopkeeper, DashBoardGrupoConcessionariasDisponvivel, DashBoardShopkeeper, FiltrosShopkeeperHome } from "../dto/ShopkeeperDTO";
import { fetchAnunciosDisponiveis, fetchDashBoardShopkeeper } from "../repository/ShopkeeperRepository";
import { leftToRight, responsiveCarousel } from "./animations/AnimationsPage";




export function AnunciosPages({ showDashboard = true }: { showDashboard?: boolean }) {
const { setToast } = useToastStore();
const [loading, setLoading] = useState(true);
const theme = useTheme();
const isMobile = useMediaQuery(theme.breakpoints.down("md"));
const [selectedId, setSelectedId] = useState<number | null>(null);
const [ordenacao, setOrdenacao] = useState("padrao");
const [dashboardApi, setDashboardApi] = useState<DashBoardShopkeeper>();
const [dashboardConcessionaria, setDashboardConcessionaria] = useState<DashBoardGrupoConcessionariasDisponvivel[]>([]);
const [filtros, setFiltrosShopkeeper] = useState<FiltrosShopkeeperHome | null>( null);
const jaCarregou = useRef(false);
const [openAnuncioId, setOpenAnuncioId] = useState<number | null>(null);
const [combustiveisSelecionados, setCombustiveisSelecionados] = useState<string[]>([]);
const [tipoSelecionado, setTipoSelecionado] = useState<string[]>([]);
const [marcasSelecionadas, setMarcasSelecionadas] = useState<string[]>([]);
const [preco, setPreco] = useState<[number, number]>([0, 999000]);
const [searchText, setSearchText] = useState("");
const [anuncios, setAnuncios] = useState<AnunciosShopkeeper[]>([]);
const [current_date_servidor, sertDateServidor] = useState<string | null>(null);
const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
const [tabVeiculos, setTabVeiculos] = useState<number>(1);
const navigate = useNavigate();

const activeFiltersCount =
  combustiveisSelecionados.length +
  tipoSelecionado.length +
  marcasSelecionadas.length +
  (preco[0] > 0 || preco[1] < 999000 ? 1 : 0) +
  (searchText.trim() ? 1 : 0);


  const dashboard = useMemo(() => {
    const hoje = current_date_servidor?.split("T")[0] ?? "";
    return {
      qtd_ativa: anuncios.length,
      finalizando_hoje: anuncios.filter(a => a.data_finalizacao?.split("T")[0] === hoje).length,
      comprados_voce: dashboardApi?.comprados_voce ?? 0,
      pagamento_aberto: dashboardApi?.pagamento_aberto ?? 0,
      em_cotacao: anuncios.filter(a => a.tipo_anuncio === "C").length,
    };
  }, [anuncios, current_date_servidor, dashboardApi]);

const anunciosFiltrados = useMemo(() => {
  const filtrados = anuncios.filter((a) => {
    /** 🔍 Busca por texto */
    const search = searchText.trim().toLowerCase();
    const matchesSearch =
      !search ||
      a.veiculos.some((v) =>
        `${v.marca ?? ""} ${v.modelo ?? ""}`.toLowerCase().includes(search)
      );

    /** 🏢 Concessionária selecionada */
    const matchesConcessionaria =
      selectedId === null || a.id_grupo_concessionaria === selectedId;

    /** 🚗 Combustível */
    const matchesCombustivel =
      combustiveisSelecionados.length === 0 ||
      a.veiculos.some((v) =>
        combustiveisSelecionados.includes(v.combustivel ?? "")
      );

    /** 🏷 Tipo de anúncio */
    const tiposNormais = tipoSelecionado.filter((t) => t !== "Combo");
    const comboSelecionado = tipoSelecionado.includes("Combo");
    const isCombo = a.veiculos.length > 1;
    const matchesTipo =
      tipoSelecionado.length === 0 ||
      (comboSelecionado && isCombo) ||
      (tiposNormais.length > 0 && tiposNormais.includes(a.tipo_anuncio));

    /** 🏭 Marca */
    const matchesMarca =
      marcasSelecionadas.length === 0 ||
      a.veiculos.some((v) =>
        marcasSelecionadas.includes(v.marca ?? "")
      );

    /** 💰 Preço */
    const valor = a.compre_agora ?? a.melhor_oferta ?? 0;
    const matchesPreco =
      valor >= preco[0] && valor <= preco[1];

    return (
      matchesSearch &&
      matchesConcessionaria &&
      matchesCombustivel &&
      matchesTipo &&
      matchesMarca &&
      matchesPreco
    );
  });

  /** 🔀 ORDENAÇÃO */
  return [...filtrados].sort((a, b) => {
    const valorA = a.compre_agora ?? a.melhor_oferta ?? 0;
    const valorB = b.compre_agora ?? b.melhor_oferta ?? 0;

    switch (ordenacao) {
      case "menor_preco":
        return valorA - valorB;

      case "maior_preco":
        return valorB - valorA;

      case "recentes":
        return (
          new Date(b.data_inicio).getTime() -
          new Date(a.data_inicio).getTime()
        );

      case "padrao":
      default:
        return 0;
    }
  });
}, [
  anuncios,
  selectedId,
  combustiveisSelecionados,
  tipoSelecionado,
  marcasSelecionadas,
  preco,
  ordenacao,
  searchText,
]);

const tabsDisponiveis = useMemo(
  () => Array.from(new Set(anunciosFiltrados.map(a => a.veiculos.length))).sort((a, b) => a - b),
  [anunciosFiltrados]
);

const anunciosTab = useMemo(
  () => anunciosFiltrados.filter(a => a.veiculos.length === tabVeiculos),
  [anunciosFiltrados, tabVeiculos]
);

const fetchDashBoard = async () => {
    try {
        const result = await fetchDashBoardShopkeeper();
        if(!result?.success) {
            setToast({variant:"error", message:result.message});
            return;
        }
        setDashboardApi(result.data);
    } catch (error) {
        setToast({variant:"error", message:"Erro. Contate o administrador."});
    }
};

const fetchAnuncios = async () => {
  try {
    const result = await fetchAnunciosDisponiveis();

    if (!result?.success) {
      setToast({ variant: "error", message: result.message });
      return;
    }

    const anunciosValidos = (result.data as AnunciosShopkeeper[])
      .filter((a) => a.veiculos && a.veiculos.length > 0);

    const marcas = Array.from(new Set(anunciosValidos.flatMap(a => a.veiculos.map(v => v.marca ?? ""))));
    const combustiveis = Array.from(new Set(anunciosValidos.flatMap(a => a.veiculos.map(v => v.combustivel ?? ""))));
    const tipos_anuncio = Array.from(new Set(anunciosValidos.map(a => a.tipo_anuncio)));

    const gruposMap = new Map<number, DashBoardGrupoConcessionariasDisponvivel>();
    anunciosValidos.forEach(a => {
      const existing = gruposMap.get(a.id_grupo_concessionaria);
      if (existing) {
        existing.qtd_disponivel += 1;
      } else {
        gruposMap.set(a.id_grupo_concessionaria, {
          id: a.id_grupo_concessionaria,
          id_concessionaria: a.id_concessionaria,
          nom_fantasia: a.des_grupo_concessionaria,
          des_logotipo: a.logo_grupo_concessionaria,
          qtd_disponivel: 1,
        });
      }
    });
    setDashboardConcessionaria(Array.from(gruposMap.values()));

    setFiltrosShopkeeper({ marcas, combustiveis, tipos_anuncio });
    sertDateServidor(result.current_date);
    setAnuncios(anunciosValidos);
  } catch {
    setToast({
      variant: "error",
      message: "Erro. Contate o administrador.",
    });
  }
};


useEffect(() => {
    if (tabsDisponiveis.length > 0 && !tabsDisponiveis.includes(tabVeiculos)) {
        setTabVeiculos(tabsDisponiveis[0]);
    }
}, [tabsDisponiveis, tabVeiculos]);

//==========PreLoad=========////
useEffect(()=>{
    const preLoadInterface = async () => {
        if (showDashboard) {
            await fetchDashBoard();
        }
        await fetchAnuncios();
        setLoading(false);
    };
    if(jaCarregou.current) return;
    jaCarregou.current=true;
    preLoadInterface();
},);


if (loading) {
    return <Loading fullScreen= {true}></Loading>
}

const filterContent = (
    <Box display="flex" flexDirection="column" gap={3} sx={isMobile ? { p: 2, width: 300 } : {}}>
        {isMobile && (
            <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Typography fontWeight={700} fontSize="1.1rem" color={colorPrimary}>
                    Filtros
                </Typography>
                <IconButton onClick={() => setFilterDrawerOpen(false)}>
                    <CloseIcon />
                </IconButton>
            </Stack>
        )}
        <SearchCard
            value={searchText}
            onChange={setSearchText}
        />
        {filtros && (
            <TipoFilterCard
                values={filtros.tipos_anuncio.length > 0 ?['Combo',...filtros.tipos_anuncio.map((f) => f )] : []}
                selected={tipoSelecionado}
                onChange={setTipoSelecionado}
            />
        )}
        {filtros && (
            <MarcasFilterCard
                marcas={filtros.marcas.length > 0 ? filtros?.marcas.map((m) => m) : []}
                selected={marcasSelecionadas}
                onChange={setMarcasSelecionadas}
            />
        )}
        <PrecoFilterCard
            min={0}
            max={999000}
            value={preco}
            onChange={setPreco}
        />
        {filtros && (
            <CombustivelFilterCard
                combustiveis={filtros.combustiveis.length > 0 ? filtros.combustiveis.map((c) => c) : []}
                selected={combustiveisSelecionados}
                onChange={setCombustiveisSelecionados}
            />
        )}
    </Box>
);

return (
    <>
    <Box width="100%" minHeight={0} display="flex" flexDirection="column">
        {showDashboard && (<>
        <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            width="100%"
            px={isMobile ? 2 : 0}
        >
            <Box display="flex" flexDirection="column" gap={1}>
                <Typography
                    fontWeight="bold"
                    fontSize={isMobile ? "1.6rem" : "2.6rem"}
                    variant="h1"
                    color={colorPrimary}
                    fontStyle="Inter"
                >
                    Resumo
                </Typography>
                <Stack direction="row" gap={2} justifyContent="center" alignItems="center">
                    <Box
                        bgcolor={colorPrimary}
                        width="60%"
                        height={10}
                        borderRadius={10}
                        sx={{ animation: `${leftToRight} 1.8s ease-in-out infinite` }}
                    />
                </Stack>
            </Box>
        </Stack>

        <Box
            display="grid"
            maxWidth="1200px"
            width="100%"
            gridTemplateColumns={isMobile ? "repeat(2, 1fr)" : "repeat(auto-fit, minmax(200px, 1fr))"}
            gap={isMobile ? 1.5 : 2}
            mt={isMobile ? 2 : 4}
            mx="auto"
            px={isMobile ? 1.5 : 2}
            justifyItems="center"
            alignItems="center"
        >
            <ResumoCard value={dashboard.qtd_ativa} label="Ofertas Ativas" colorPrimary={colorPrimary} colorSubText={colorSubText} />
            <ResumoCard value={dashboard.finalizando_hoje} label="ENCERRANDO HOJE" colorPrimary={colorPrimary} colorSubText={colorSubText} />
            <ResumoCard value={dashboard.comprados_voce} label="COMPRADOS POR VOCÊ" colorPrimary={colorPrimary} colorSubText={colorSubText} navigation={() => navigate("/minha-conta/lojista")} />
            <ResumoCard value={dashboard.pagamento_aberto} label="PAGAMENTO EM ABERTO" colorPrimary={colorPrimary} colorSubText={colorSubText} navigation={() => navigate("/minha-conta/lojista")} />
            <ResumoCard value={dashboard.em_cotacao} label="EM COTAÇÃO" colorPrimary={colorPrimary} colorSubText={colorSubText} navigation={() => setTipoSelecionado(['C'])} />
        </Box>

        <Box
            maxWidth="1200px"
            width="100%"
            mt={isMobile ? 2 : 4}
            mx="auto"
            px={isMobile ? 0 : 2}
            overflow="hidden"
        >
            <CarouselContainer $numberOfItems={dashboardConcessionaria.length}>
                <Carousel
                    responsive={responsiveCarousel}
                    infinite={dashboardConcessionaria.length > 5}
                    autoPlay
                    arrows={!isMobile}
                >
                    {dashboardConcessionaria.map((item: DashBoardGrupoConcessionariasDisponvivel) => (
                        <CarouselItem key={item.id}>
                            <ConcessionariaMiniCard
                                logoUrl={`https://www.canaldorepasse.com.br/cadastros/fotos/grupo_concessionaria/${item.id}/${item.des_logotipo}`}
                                nome={item.nom_fantasia}
                                anuncios={item.qtd_disponivel}
                                selected={selectedId === item.id}
                                onClick={() => setSelectedId(item.id)}
                            />
                        </CarouselItem>
                    ))}
                </Carousel>
            </CarouselContainer>
        </Box>
        </>)}

        <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            width="100%"
            mt={isMobile ? 3 : 6}
            px={isMobile ? 2 : 0}
        >
            <Typography
                fontWeight="bold"
                fontSize={isMobile ? "1.6rem" : "2.6rem"}
                variant="h1"
                fontFamily="roboto"
                color={colorPrimary}
            >
                Marketplace
            </Typography>
        </Stack>

        {/* Mobile: Drawer de filtros */}
        {isMobile && (
            <Drawer
                anchor="left"
                open={filterDrawerOpen}
                onClose={() => setFilterDrawerOpen(false)}
                PaperProps={{ sx: { borderRadius: "0 16px 16px 0" } }}
            >
                {filterContent}
            </Drawer>
        )}

        <Stack
            display="flex"
            flexDirection={isMobile ? "column" : "row"}
            maxWidth={1300}
            width="100%"
            mx="auto"
            px={isMobile ? 1.5 : 3}
            gap={isMobile ? 2 : 3}
            mt={isMobile ? 2 : 4}
        >
            {/* Desktop: sidebar de filtros */}
            {!isMobile && (
                <Box display="flex" flexDirection="column" width={240} flexShrink={0} gap={3}>
                    {filterContent}
                </Box>
            )}

            <Box flex={1} display="flex" flexDirection="column" minWidth={0}>
                {tabsDisponiveis.length > 1 && (
                    <Stack direction="row" gap={1} mb={2} flexWrap="wrap">
                        {tabsDisponiveis.map((qtd) => {
                            const count = anunciosFiltrados.filter(a => a.veiculos.length === qtd).length;
                            return (
                                <Box
                                    key={qtd}
                                    onClick={() => setTabVeiculos(qtd)}
                                    sx={{
                                        px: 2,
                                        py: 0.8,
                                        borderRadius: 5,
                                        fontWeight: 600,
                                        fontSize: "0.85rem",
                                        cursor: "pointer",
                                        transition: "all 0.2s",
                                        userSelect: "none",
                                        bgcolor: tabVeiculos === qtd ? colorPrimary : "grey.100",
                                        color: tabVeiculos === qtd ? "white" : "text.secondary",
                                        "&:hover": { bgcolor: tabVeiculos === qtd ? colorPrimary : "grey.200" },
                                    }}
                                >
                                    {qtd === 1 ? `1 Veículo (${count})` : `${qtd} Veículos (${count})`}
                                </Box>
                            );
                        })}
                    </Stack>
                )}

                <Stack
                    direction={isMobile ? "column" : "row"}
                    alignItems={isMobile ? "stretch" : "center"}
                    justifyContent="space-between"
                    gap={isMobile ? 1.5 : 0}
                    mb={2}
                >
                    <Stack
                        direction="row"
                        alignItems="center"
                        spacing={1}
                        flexWrap="wrap"
                    >
                        {isMobile && (
                            <IconButton
                                onClick={() => setFilterDrawerOpen(true)}
                                sx={{
                                    bgcolor: "primary.main",
                                    color: "white",
                                    borderRadius: 2,
                                    px: 1.5,
                                    "&:hover": { bgcolor: "primary.dark" },
                                }}
                            >
                                <Badge badgeContent={activeFiltersCount} color="error">
                                    <FilterListIcon />
                                </Badge>
                            </IconButton>
                        )}

                        <Typography
                            fontWeight={600}
                            color="text.primary"
                            fontSize={isMobile ? "0.85rem" : "1rem"}
                        >
                            Mostrando {anunciosTab.length} resultados
                        </Typography>

                        {selectedId !== null && (
                            <Box
                                sx={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                    px: 1.5,
                                    py: 0.5,
                                    borderRadius: 2,
                                    bgcolor: "primary.main",
                                    color: "white",
                                    fontSize: "0.8rem",
                                    fontWeight: 600,
                                    cursor: "pointer",
                                    transition: "all 0.2s",
                                    "&:hover": { bgcolor: "primary.dark" },
                                }}
                                onClick={() => setSelectedId(null)}
                            >
                                <Typography fontSize="0.8rem" fontWeight={600} noWrap sx={{ maxWidth: isMobile ? 120 : "none" }}>
                                    {dashboardConcessionaria.find(c => c.id === selectedId)?.nom_fantasia || "Filtrado"}
                                </Typography>
                                <Box component="span" sx={{ fontSize: "1.1rem", lineHeight: 1 }}>×</Box>
                            </Box>
                        )}
                    </Stack>

                    <FormControl size="small" sx={{ minWidth: isMobile ? "100%" : 220 }}>
                        <Select
                            value={ordenacao}
                            onChange={(e) => setOrdenacao(e.target.value)}
                            displayEmpty
                            sx={{
                                borderRadius: 3,
                                bgcolor: "white",
                                "& .MuiOutlinedInput-notchedOutline": {
                                    borderRadius: 3,
                                    boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                                    border: "1px solid",
                                    borderColor: "divider",
                                },
                                "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: colorPrimary },
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: colorPrimary, borderWidth: "2px" },
                            }}
                        >
                            <MenuItem value="padrao">Ordenação padrão</MenuItem>
                            <MenuItem value="menor_preco">Menor preço</MenuItem>
                            <MenuItem value="maior_preco">Maior preço</MenuItem>
                            <MenuItem value="recentes">Mais recentes</MenuItem>
                        </Select>
                    </FormControl>
                </Stack>

                <AnuncioGrid>
                    {anunciosTab.map((a) => {
                        a.current_date = current_date_servidor!;
                        const isCombo = a.veiculos.length > 1;
                        const titulo = isCombo
                            ? `Combo de ${a.veiculos.map((v) => (v.modelo ?? "").split(" ")[0]).join(" + ")}`
                            : `${a.veiculos[0].marca ?? ""} ${a.veiculos[0].modelo ?? ""}`;
                        const isOpen = openAnuncioId === a.num_id_anuncio;
                        return (
                            <AnuncioItemCard
                                anuncio={a}
                                open={isOpen}
                                id_anuncio={a.num_id_anuncio}
                                onToggle={() => setOpenAnuncioId(isOpen ? null : a.num_id_anuncio)}
                                key={a.num_id_anuncio}
                                highlighted
                                imagens={a.veiculos.map((i) =>
                                    resolveAssetUrl(i.url_foto ?? "", a.num_id_anuncio)
                                )}
                                status={a.tipo_anuncio}
                                titulo={titulo}
                                veiculos={a.veiculos.map((v) => ({
                                    titulo: `${v.marca ?? ""} - ${v.modelo ?? ""}`,
                                    itens: [
                                        { icon: <CalendarTodayIcon sx={{ color: colorPrimary }} />, label: `${v.ano_fabricacao ?? ""}/${v.ano_modelo ?? ""}` },
                                        { icon: <PodcastsIcon sx={{ color: colorPrimary }} />, label: v.transmissao ?? "" },
                                        { icon: <SpeedIcon sx={{ color: colorPrimary }} />, label: `${(v.km ?? 0).toLocaleString("pt-BR")} km` },
                                        { icon: <LocalGasStationIcon sx={{ color: colorPrimary }} />, label: v.combustivel ?? "" },
                                    ],
                                }))}
                                footer={{
                                    compreAgora: formatCurrencyBRL(a.compre_agora ?? 0),
                                    melhorOferta: formatCurrencyBRL(a.melhor_oferta ?? 0),
                                    tipoAnuncio: a.tipo_anuncio,
                                    actionLabel: isCombo ? "Comprar Combo" : "Ver Detalhes",
                                    onAction: () => {
                                        if (isCombo) {
                                            navigate(`/anuncios/detalhe/combo/${a.num_id_anuncio}`);
                                        } else {
                                            navigate(`/anuncios/detalhe/${a.num_id_anuncio}`);
                                        }
                                    },
                                    id_concessionaria: a.id_concessionaria,
                                    logo: a.logo_concessionaria,
                                    cidade: a.cidade,
                                    uf: a.uf,
                                }}
                            />
                        );
                    })}
                </AnuncioGrid>
            </Box>
        </Stack>
    </Box>
    </>
);
}